import { render, staticRenderFns } from "./ButtonRipple.vue?vue&type=template&id=5a9ca79a&"
import script from "./ButtonRipple.vue?vue&type=script&lang=js&"
export * from "./ButtonRipple.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRipple.vue?vue&type=style&index=0&id=5a9ca79a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports